<template>
  <div class="downLoad">
    <div class="tip">
        <div class="title">提示：</div>
        <div class="content">如果微信无法下载，请通过右上角功能中的浏览器打开</div>
    </div>

    <div class="linkBox">
        <img :src="appName=='高新企服通'?'/static/logo.png':'/static/lplogo.png'" alt="logo">
        <div class="name">{{ appName || '临平新城企服通' }}</div>
        <mt-button type="default" @click="download">点击下载</mt-button>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui';
  export default {
    name: 'downLoad',
    data () {
      return {
        appName:''
        // androidUrl:'https://download.zhengce001.com/linping1.1.3.apk',
        // IOSUrl:'https://apps.apple.com/cn/app/%E9%AB%98%E6%96%B0%E4%BC%81%E6%9C%8D%E9%80%9A/id1550906594',
      }
    },
    activated(){
      //获取数据
      const {
        query: { appName },
      } = this.$route;
      this.appName=appName;
      // this.download();
    },
    methods:{
      async getDownloadUrl(appType){
        const { appName }=this;
        if(!appName){
          window.location.href=appType==1?'https://download.zhengce001.com/linping1.1.3.apk':'https://apps.apple.com/cn/app/%E6%96%B0%E5%9F%8E%E4%BC%81%E6%9C%8D%E9%80%9A/id1518969288';
          return;
        }
        const res=await this.$ajax.post(`${process.env.baseURL}/appDetail/getAppDetailByName`,{appName,appType});
        const { code,data,msg }=res.data
        if(code==1 && data && data.appUrl){
          window.location.href=data.appUrl;
        } else{
          Toast('暂时无法下载');
        } 
      },
      getDeviceState() {
        var ua = navigator.userAgent.toLowerCase();
        var state = "default";
        if (ua.indexOf("android") > -1) {
          state = "android";
        } else if (ua.indexOf("xiaomi") > -1) {
          state = "xiaomi";
        } else if (ua.indexOf("iphone") > -1) {
          state = "iphone";
        } else if (ua.indexOf("ipad") > -1) {
          state = "ipad";
        }
        return state;
      },
      download() {    
        const { androidUrl,IOSUrl }=this;
        const state = this.getDeviceState();
        console.log(state)
        switch (state) {
          // case "android":
          //   getDownloadUrl(1);
          //   break;
          // case "xiaomi":
          //   getDownloadUrl(1);
          //   break;
          case "iphone":
            this.getDownloadUrl('2');
            break;
          case "ipad":
            this.getDownloadUrl('2');
            break;
          default:
            this.getDownloadUrl('1');
            break;
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .downLoad{
      width: 100%;
      padding: 40px 30px;
      box-sizing: border-box;
    .tip{
        width: 100%;
        height: auto;
        padding: 15px 28px;
        box-sizing: border-box;
        background: #F2F6FA;
        border: 1px solid rgba(21,130,243,0.30);
        border-radius: 6px;
        .title{
            font-size: 30px;
            color: #1582F3;
            letter-spacing: 0;
        }
        .content{
            font-size: 24px;
            color: #999999;
            letter-spacing: 0;
            text-indent: 48px;
        }
    }
    .linkBox{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
            width: 142px;
            height: 142px;
            margin-top: 80px;
        }
        .name{
            font-size: 24px;
            color: #1582F3;
            letter-spacing: 0;
            text-align: center;
            margin-top: 20px;
            width: 100%;
        }
        .mint-button{
            margin-top: 20px;
            width: 360px;
            height: 88px;
            line-height: 88px;
            background: #1582F3;
            border-radius: 6px;
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/downLoad.vue